import { ProfileItemsSortBy } from "@opensea/graphql"
import { toLowerCase, toUpperCase } from "@opensea/utils"
import { parseAsStringLiteral, useQueryState } from "nuqs"
import { useFilterDefaults } from "@/components/layout/FilterDefaultsProvider"
import { QUERY_PARAM_KEYS } from "./keys"

const parser = parseAsStringLiteral(ProfileItemsSortBy.map(v => toLowerCase(v)))

export function useProfileItemsSortByQueryParam() {
  const { sortBy: defaultSortBy } = useFilterDefaults()

  const [sortBy, setSortBy] = useQueryState(
    QUERY_PARAM_KEYS.sortBy,
    parser.withDefault(defaultSortBy ?? "received_date"),
  )

  async function onSelectSortBy(value: ProfileItemsSortBy) {
    await setSortBy(toLowerCase(value))
  }

  return {
    sortBy: toUpperCase(sortBy),
    onSelectSortBy,
    clearSortBy: () => setSortBy(null, { clearOnDefault: true }),
  }
}
